import { render } from "./TransitaireDossiersPage.vue?vue&type=template&id=1c017080&ts=true"
import script from "./TransitaireDossiersPage.vue?vue&type=script&lang=ts"
export * from "./TransitaireDossiersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__